import React from 'react';
import './componentsCSS/GraphButtons.css';
import {GraphType} from "../types/types";

interface GraphButtonsProps {
    selectedGraph: string;
    setSelectedGraph: (graph: string) => void;
}

const GraphButtons = (props: GraphButtonsProps) => {
    const onClickGraphButton = (graph: string) => {
        props.setSelectedGraph(graph);
    }

    return (
        <div className="graph-buttons-container">
            <button
                onClick={() => onClickGraphButton(GraphType.Age)}
                disabled={props.selectedGraph === GraphType.Age}
                className={`graph-button ${props.selectedGraph === GraphType.Age ? "active" : ""}`}
            >
                Age Breakdown
            </button>
            <span className="separator">|</span>
            <button
                onClick={() => onClickGraphButton(GraphType.Gender)}
                disabled={props.selectedGraph === GraphType.Gender}
                className={`graph-button ${props.selectedGraph === GraphType.Gender ? "active" : ""}`}
            >
                Gender Breakdown
            </button>
        </div>
    );
};

export default GraphButtons;
